import React from 'react';
import { ButtonProps } from '@cp/ds/src/components/button/model';
import { useClientLogin } from '../../model';
// FIXME sibling import
import { LoginButton as AuthButton } from '../../../../../auth';

export type LoginButtonProps = ButtonProps;

export const LoginButton = (props: LoginButtonProps) => {
  const login = useClientLogin();
  return <AuthButton onClick={() => login()} {...props} />;
};
